module.exports = __webpack_public_path__ + "static/media/act04.c4d99fdd.m4a";